// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"349565ad","304":"10e97cc1","328":"631e7352","819":"602e34e1","859":"e84212c6","931":"60c89825"}[chunkId] + ".chunk.js";
};